export default __webpack_public_path__ + "static/media/1-8@2x.9df23aba.png";